module.exports = __webpack_public_path__ + "media/bootstrap-icons/moon-fill-fccae081.svg";